  const { variantDims, mmToInch, gToOz } = window.__dimsData;

  function createDimSpan(label, metVal, impVal) {
    const span = document.createElement('span');
    span.className = 'feature-chart__listing';
    span.appendChild(document.createTextNode(label + ': '));

    const val = document.createElement('span');
    val.className = 'feature-chart__value feature-chart__convert';
    val.dataset.met = metVal;
    val.dataset.imp = impVal;
    val.appendChild(document.createTextNode(window.__dimsData.metric ? metVal : impVal));

    span.appendChild(val);
    return span;
  }

  function createRow(headingText, valueEl, hasContent) {
    if (!hasContent) return null;
    const row = document.createElement('div');
    row.className = 'feature-chart__table-row';

    const head = document.createElement('div');
    head.className = 'feature-chart__heading bold';
    head.appendChild(document.createTextNode(headingText));

    row.appendChild(head);
    row.appendChild(valueEl);
    return row;
  }

  function buildDimGroup(dims, prefix, label) {
    const value = document.createElement('div');
    value.className = 'feature-chart__value prose text-subdued';
    let hasContent = false;

    for (const axis of ['width', 'height', 'depth']) {
      const key = `${prefix}_${axis}`;
      if (dims[key] != null) {
        hasContent = true;
        const met = dims[key] + 'mm';
        const imp = (dims[key] / mmToInch).toFixed(2) + 'in';
        value.appendChild(createDimSpan(axis.charAt(0).toUpperCase() + axis.slice(1), met, imp));
      }
    }

    return createRow(label, value, hasContent);
  }

  function buildTable(currentID) {
    const displayTable = document.querySelector('div#col-dims_table');
    const dims = variantDims.find((variant) => variant.id == currentID);
    displayTable.textContent = '';
    let blank = true;

    for (const [prefix, label] of [['ext', 'External'], ['int', 'Internal'], ['max', 'Maximum content']]) {
      const row = buildDimGroup(dims, prefix, label);
      if (row) {
        blank = false;
        displayTable.appendChild(row);
      }
    }

    if (dims['shred'] != null) {
      blank = false;
      const met = dims['shred'] + 'g';
      const imp = (dims['shred'] / gToOz).toFixed(2) + 'oz';

      const shredValue = document.createElement('div');
      shredValue.className = 'feature-chart__value feature-chart__convert prose text-subdued';
      shredValue.dataset.met = met;
      shredValue.dataset.imp = imp;
      shredValue.appendChild(document.createTextNode(window.__dimsData.metric ? met : imp));

      const row = createRow('Shred weight', shredValue, true);
      displayTable.appendChild(row);
    }

    if (dims['gn'] != null) {
      blank = false;
      const gnValue = document.createElement('div');
      gnValue.className = 'feature-chart__value prose text-subdued';
      gnValue.appendChild(document.createTextNode(dims['gn']));

      const row = createRow('GN size', gnValue, true);
      displayTable.appendChild(row);
    }

    if (blank) {
      displayTable.appendChild(document.createTextNode(window.__dimsData.emptyDimsText));
    }
  }

  document.addEventListener('variant:change', (event) => {
    buildTable(event.detail.variant.id);
  });

  const switchInch = document.querySelector('#dimension-change');
  const savedMetric = localStorage.getItem('dimsMetric');

  if (savedMetric !== null) {
    window.__dimsData.metric = savedMetric === 'true';
    switchInch.checked = !window.__dimsData.metric;
  }

  switchInch.addEventListener('change', function () {
    window.__dimsData.metric = !this.checked;
    localStorage.setItem('dimsMetric', window.__dimsData.metric);
    document.querySelectorAll('.feature-chart__convert').forEach((el) => {
        el.textContent = window.__dimsData.metric ? el.dataset.met : el.dataset.imp;
    });
  });
    
  buildTable(window.__dimsData.initialVariantId);